module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-2.a512d82f.jpg";